(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-rtec"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-rtec-header]');
    if (!header) return;

    // Desktop dropdowns — Samsara-style: hover-only on parent, separate overview link inside
    const triggers = header.querySelectorAll('.rtec-header__menu-trigger');
    triggers.forEach(function (trigger) {
      const item = trigger.closest('.rtec-header__menu-item');

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = item.classList.contains('is-open');
        header.querySelectorAll('.rtec-header__menu-item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          const t = el.querySelector('.rtec-header__menu-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) {
        header.querySelectorAll('.rtec-header__menu-item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          const t = el.querySelector('.rtec-header__menu-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        header.querySelectorAll('.rtec-header__menu-item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          const t = el.querySelector('.rtec-header__menu-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Mobile drawer
    const burger = header.querySelector('[data-rtec-burger]');
    const drawer = header.querySelector('[data-rtec-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        const isOpen = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!isOpen));
        drawer.setAttribute('aria-hidden', String(isOpen));
      });

      const drawerTriggers = drawer.querySelectorAll('.rtec-header__drawer-trigger');
      drawerTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          const item = trigger.closest('.rtec-header__drawer-item');
          const isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
